module.exports = __webpack_public_path__ + "assets/icon-lock.762d0b0e.svg";